import React, { forwardRef } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentHomeFilled = forwardRef<Svg, { fillColor?: string } & SvgProps>(
  (
    { fillColor = '#212121', ...props }: { fillColor?: string } & SvgProps,
    ref
  ) => (
    <Svg
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      ref={ref}
      {...props}
    >
      <Path
        d='M10.55 2.533a2.25 2.25 0 012.9 0l6.75 5.695c.508.427.8 1.056.8 1.72v9.802a1.75 1.75 0 01-1.75 1.75h-3a1.75 1.75 0 01-1.75-1.75v-5a.75.75 0 00-.75-.75h-3.5a.75.75 0 00-.75.75v5a1.75 1.75 0 01-1.75 1.75h-3A1.75 1.75 0 013 19.75V9.947c0-.663.292-1.292.8-1.72l6.75-5.694z'
        fill={fillColor}
      />
    </Svg>
  )
)

FluentHomeFilled.displayName = 'FluentHomeFilled'

export default FluentHomeFilled
